import * as React from "react";

function SvgLogout(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.585 0a2.902 2.902 0 00-2.902 2.902v13.269a2.903 2.903 0 005.805 0V2.902C19.488 1.3 18.188 0 16.585 0z"
        fill="#fff"
      />
      <path
        d="M7.419 6.358a2.073 2.073 0 00-3.09-2.765A16.944 16.944 0 000 14.927c0 9.389 7.611 17 17 17s17-7.611 17-17c0-4.353-1.639-8.328-4.33-11.334a2.073 2.073 0 10-3.089 2.765 12.798 12.798 0 013.273 8.569c0 7.099-5.755 12.854-12.854 12.854-7.099 0-12.854-5.755-12.854-12.854 0-3.294 1.236-6.293 3.273-8.569z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLogout;
